<template>
  <case-update-card
    :info-item="document"
    :icon="'mdi-file-document'"
    :header="document.attachmentName"
    :status=" document.documentType"
    :status-display-name="local.caseFile.cards.document.typeDisplayName"
    :date="document.createDate"
    :date-display-name="local.caseFile.cards.document.dateDisplayName"
    :has-actions="true"
    :court-name="document.courtName"
    :sub-circle-name="document.subCircleName"
    @card-click="$emit('document-card-click',document)"
  >
  </case-update-card>
</template>

<script>
import CaseUpdateCard from './case-update-card.vue';

export default {
  name: 'DocumentCard',
  components: { CaseUpdateCard },
  props: {
    document: {
      type: Object,
      required: true,
    },
    caseObjectKey: {
      default: null,
      type: String,
      require: true,
    },
    isPega: {
      type: [String, Boolean],
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};

</script>
<style scoped>
.header-text {
  font-size: 18px;
}

::v-deep .case-update-card-header {
  color: var(--app-dark-primary-color);
  font-size: 25px;
}
</style>
